import React, { useState } from "react"
import { Flex, Box, Button, Text } from "rebass"
import styled from "@emotion/styled"
import { motion } from "framer-motion"

import Reveal from "../reveals"
import RowWrapper from "./RowWrapper"

const RowFaqsComponent = ({ data }) => {
  const {
    title,
    titleHeadingTag,
    text,
    alignItems,
    justifyContent,
    revealAnimation,
    faqsFaqs,
  } = data

  const [selectedTabIndex, setSelectedTabIndex] = useState()

  return (
    <RowWrapper {...data}>
      <Flex
        flexDirection={["column", null, "row"]}
        justifyContent={justifyContent}
        alignItems={alignItems}
      >
        <Box as="aside" width={[1, null, "30%"]}>
          {title && (
            <Reveal animation={revealAnimation}>
              <Flex
                justifyContent="center"
                alignItems="center"
                width={93}
                height={93}
                sx={{
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderColor: "currentColor",
                  borderRadius: "circle",
                }}
              >
                <Text as={titleHeadingTag} m={0} p={0} fontFamily="heading" fontWeight="normal">{title}</Text>
              </Flex>
            </Reveal>
          )}

          {text && (
            <Box
              dangerouslySetInnerHTML={{ __html: text }}
              textAlign={justifyContent}
            />
          )}
        </Box>

        <Box as="aside" width={[1, null, "70%"]} mt={[3, null, 0]}>
          {faqsFaqs.map((faq, index, array) => {
            return (
              <Box key={index}>
                <Reveal delay={0.15 * index} animation={revealAnimation}>
                  <Button
                    variant="faq"
                    className={selectedTabIndex === index && '--selected'}
                    onClick={() => setSelectedTabIndex(selectedTabIndex !== index ? index : null)}
                    color={selectedTabIndex === index ? 'primary' : null}
                  >
                    {faq.title}
                  </Button>

                  <motion.section
                    initial={{ height: 0 }}
                    animate={{ height: selectedTabIndex === index ? 'auto' : 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "circOut",
                    }}
                    style={{
                      overflow: 'hidden'
                    }}
                  >
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: selectedTabIndex === index ? 1 : 0 }}
                      transition={{
                        duration: selectedTabIndex === index ? 0.5 : 0.2,
                        ease: "linear",
                      }}
                    >
                      <Text
                        as={FaqText}
                        pl={["14px", null, "30px"]}
                        pr={["14px", null, 5]}
                        pb={[4]}
                        dangerouslySetInnerHTML={{ __html: faq.text }}
                      />
                    </motion.div>
                  </motion.section>

                  {index < array.length - 1 && <Box as={Line} />}
                </Reveal>
              </Box>
            )
          })}
        </Box>
      </Flex>
    </RowWrapper>
  )
}

export default RowFaqsComponent

const Line = styled.hr`
  border-top: none;
  border-bottom: 1px solid #979797;
  width: 100%;
  height: 1px;
`

const FaqText = styled.div`
  h1, h2, h3, h4, h5 {
    font-family: ${props => props.theme.fonts.body};
  }
`
